import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import ChallanList from './ChallanList';
import ChallanForm from './ChallanForm';

/** /challans = list, /challans/new = new challan, /challans/:id = edit challan. */
function parseChallansRoute(pathname) {
  const parts = String(pathname || '').replace(/\/+$/, '').split('/').filter(Boolean);
  if (parts[0] !== 'challans' || parts.length === 1) return { view: 'list' };
  if (parts[1] === 'new') return { view: 'form', id: null };
  return { view: 'form', id: parts[1] };
}

export default function Challans() {
  const location = useLocation();
  const route = useMemo(() => parseChallansRoute(location.pathname), [location.pathname]);
  if (route.view === 'list') return <ChallanList />;
  // Same page frame as the order detail page (Orders.js). key: a fresh form for "new" vs an existing challan.
  return (
    <div className="mx-auto flex min-h-0 flex-1 w-full max-w-[1500px] flex-col">
      <ChallanForm key={route.id || 'new'} challanId={route.id} />
    </div>
  );
}
